import { getPageRoute } from '@/router/common';
const viewPath = 'custom/huizhi/views';
const allergan = [
  'PointsRule',
  'PointsRule/edit',
  'EmployeeMaintenance',
  'EmployeeMaintenance/edit',
].map((r) => (typeof r === 'string' ? getPageRoute([r], viewPath) : getPageRoute(r, viewPath)));
export default allergan;
